import { Box } from '@mui/material';
import formatNumberWithCommas from 'src/compass/shared/util/formatNumberWithCommas';
import { ICasMRTCellProps } from './ICasMRTCellProps';

export default function CasMRTCellRenderNumberWithCommas({ cell }: ICasMRTCellProps) {
  const value = cell.getValue();
  return value !== null
   && <Box textAlign="right">{formatNumberWithCommas(value)}</Box>;
}
